import Page from './settings.page.vue'

let routes = [
  {
    path: 'settings',
    name: 'settings',
    component: Page
  }
]

export default routes
